// extracted by mini-css-extract-plugin
export var footer = "newsletter-footer-module--footer--d06f5";
export var pixel = "newsletter-footer-module--pixel--20c1f";
export var spin = "newsletter-footer-module--spin--bb856";